import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import api from '@/axios';
import { UPDATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_RESOLUTION_KEY } from '@/keys';
import type { CorrectionRequest } from '@/types/core/purchase-order/correction-request';

type UpdateProductionDeclarationCorrectionRequestResolutionVariables = {
  commodityOriginId: string;
  correctionRequestId: string;
  isResolved: boolean;
  materialId: string;
  productionDeclarationId: string;
};

async function updateProductionDeclarationCorrectionRequestResolution({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  correctionRequestId,
  isResolved,
}: UpdateProductionDeclarationCorrectionRequestResolutionVariables): Promise<CorrectionRequest> {
  const response = await api.patch<CorrectionRequest>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/correction-requests/${correctionRequestId}/resolution`,
    {
      isResolved,
    },
  );

  return response.data;
}

export function useUpdateProductionDeclarationCorrectionRequestResolution(): UseMutationResult<
  CorrectionRequest,
  Error,
  UpdateProductionDeclarationCorrectionRequestResolutionVariables
> {
  return useMutation({
    mutationKey:
      UPDATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_RESOLUTION_KEY,
    mutationFn: updateProductionDeclarationCorrectionRequestResolution,
  });
}
